import React from "react";
import styled from "styled-components";
import { Fonts, HyperLink } from "yuka";

import { ROUTING_PATH } from "../routes/constants";
import useDocumentTitle from "../utils/useDocumentTitle";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  gap: 16px;
  padding: 48px;
  text-align: center;
`;

/**
 * 404 page rendered when the user navigates to an unknown route.
 *
 * @returns {React.Element}
 */
const NotFound = () => {
  useDocumentTitle("ZXData: Page Not Found");
  return (
    <Container>
      <Fonts.Headline1theme80>404</Fonts.Headline1theme80>
      <Fonts.Headline3theme80>Page not found</Fonts.Headline3theme80>
      <Fonts.Body1theme50>
        The page you are looking for does not exist or has been moved.
      </Fonts.Body1theme50>
      <HyperLink url={ROUTING_PATH.COMPANIES()}>Go to Companies</HyperLink>
    </Container>
  );
};

export default NotFound;
